/** @type {import('next').NextConfig} */
const nextConfig = {
  reactStrictMode: true,
  productionBrowserSourceMaps: true,
  images: {
    remotePatterns: [
      {
        protocol: "https",
        hostname: "**",
      },
    ],
    unoptimized: true,
  },
  trailingSlash: true,
  async redirects() {
    return [
      {
        source: "/workflow-templates/:path*/",
        destination: "/form-templates/",
        permanent: true,
      },
      {
        source: "/contracts",
        destination: "/signature/contracts",
        permanent: true,
      },
      {
        source: "/signature/lifetime-deal-v2",
        destination: "/signature/lifetime-deal",
        permanent: true,
      },
      {
        source: "/signature/lifetime-offer",
        destination: "/signature/lifetime-deal",
        permanent: true,
      },
      {
        source: "/signature/lifetime-plan",
        destination: "/signature/lifetime-deal",
        permanent: true,
      },
      {
        source: "/signature/lifetime-value-offer",
        destination: "/signature/lifetime-deal",
        permanent: true,
      },
      {
        source: "/signature/super-awesome-deal",
        destination: "/signature/lifetime-deal",
        permanent: true,
      },

      {
        source: "/signature/super-yearly-awesome-deal",
        destination: "/signature/lifetime-deal",
        permanent: true,
      },
      {
        source: "/signature/yearly-awesome-deal",
        destination: "/signature/lifetime-deal",
        permanent: true,
      },
      {
        source: "/signature/deals/l/:path*",
        destination: "/signature/pricing",
        permanent: true,
      },
      {
        source: "/signature/lifetime-deal",
        destination: "/signature/pricing",
        permanent: true,
      },
      {
        source: "/signature/limited-lifetime-deal",
        destination: "/signature/pricing",
        permanent: true,
      },
      {
        source: "/signature/super-lifetime-deal",
        destination: "/signature/pricing",
        permanent: true,
      },
      {
        source: "/signature/super-lifetime-dealv2",
        destination: "/signature/pricing",
        permanent: true,
      },
      {
        source: "/signature/ultimate-lifetime-deal",
        destination: "/signature/pricing",
        permanent: true,
      },
      {
        source: "/signature/lifetime-deal",
        destination: "/signature/pricing",
        permanent: true,
      },
      {
        source: "/signature/deals/l/:path*",
        destination: "/signature/pricing",
        permanent: true,
      },






    ];
  },
  // optimizeFonts: false,
  // experimental: {
  //   fontLoaders: [
  //     { loader: "@next/font/google", options: { subsets: ["latin"] } },
  //   ],
  // },
};

module.exports = nextConfig;
